<template>
  <div id="tablePage">
    <!-- 我的交收申请查询 (铺货查询)-->
    <div class="orderTable">
      <el-table
        ref="tableData"
        :data="tableData"
        :height="tableHeight"
        v-loading="loading"
      >
        <template slot="empty" v-if="!loading">
          <div v-if="isNetWrong" class="no-datas">
            <div class="no-data-img">
              <img src="../../../assets/images/no_data.png" alt="" style="width: 100%;">
            </div>
            <div class="no-data" style="margin-top: -15px !important; text-align: center;" @click="showData">加载失败,点击重试</div>
          </div>
          <div v-else class="no-datas">
            <div class="no-data-img">
              <img src="../../../assets/images/no_data.png" alt="" style="width: 100%;">
            </div>
            <div class="no-data">暂无数据</div>
          </div>
        </template>
        <el-table-column type="index" label="序号" width="80">
        </el-table-column>
        <el-table-column
          prop="commodityName"
          label="交易品种"
        >

        </el-table-column>
        <el-table-column
          prop="ChBsFlag"
          label="方向"
        >
        </el-table-column>

        <!-- <el-table-column
          prop="storageName"
          label="仓库"
          min-width="155"
        >
        </el-table-column> -->

        <el-table-column
          prop="quantity"
          label="数量"
        >
        </el-table-column>
        <el-table-column
          prop="tradePrice"
          label="交收价格"
        >
        </el-table-column>
        <!-- <el-table-column
          prop="quantity"
          label="总重量"
        >
        </el-table-column> -->
        <el-table-column
          prop="status"
          label="状态"
        >
          <template slot-scope="scope">
            <!-- 已委托,已撤销,处理中 -->
            <!-- <span> {{ scope.row.status | seletApplyStatus }}</span> -->
            <span>已完成</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="申请时间"
          min-width="155"
        >
          <template slot-scope="scope">
            <span> {{ scope.row.createTime | dateFormateSfDay }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
        >
          <template v-if="scope.row.isRevoke==='Y'" slot-scope="scope">
            <!-- 已委托可撤销,申请中不可撤销  -->
            <span style="cursor:pointer;color:#2382fa" @click="cancleOrder(scope.row)">撤销</span>
          </template>
        </el-table-column>
      </el-table>
      <el-row v-if="pageData.total">
        <el-col :span="24" class="paginateWrap">
          <el-pagination
            popper-class="_popStyle"
            :current-page="pageData.currentPage"
            :page-sizes="pageData.pageSizes"
            :page-size="pageData.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pageData.total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          ></el-pagination>
        </el-col>
      </el-row>
    </div>
    <el-dialog
      class="newPopup"
      :visible.sync="dialogVisible1"
    >
      <span>确认撤销交收申请吗?</span>
      <span slot="footer" class="dialog-footer">
        <el-button class="canclexBtn" @click="dialogVisible1 = false">取消</el-button>
        <el-button class="surexBtn" type="primary" @click="revokeConfirm">确定</el-button>
      </span>
    </el-dialog>

  </div>
</template>
<script>
/*global http*/
import { mapGetters } from 'vuex'
import protocolSS from '../protocol/protocolSS'
export default {
  // eslint-disable-next-line vue/require-prop-types
  props: ['isSearch'],
  data() {
    return {
      tableHeight: 0,
      loading: false,
      dialogVisible1: false,
      tableData: [],
      pageData: {
        total: null,
        pageSizes: [10, 20, 30, 40],
        pageSize: 20,
        currentPage: 1
      },
      isNetWrong: false,
      spreadGoodsId: null
    }
  },

  computed: {
    ...mapGetters(['sessionInfoGetter'])
  },
  watch: {
    isSearch(val) {
      if (val) {
        this.pageData.currentPage = 1
        this.showData()
      }
    }
  },
  created() {
    window.onresize = () => {
      this.$nextTick(() => {
        this.tableHeight = util.autoHeightTable(this.$refs.tableData.$el.offsetTop + 32)
      })
    }
  },
  updated() {
    this.$nextTick(() => {
      this.tableHeight = util.autoHeightTable(this.$refs.tableData.$el.offsetTop + 32)
      this.$refs['tableData'].doLayout()
    })
  },
  mounted() {
    this.showData()
  },
  methods: {
    revokeConfirm() {
      const that = this
      protocolSS.param_deleteSpreadGoods.param.spreadGoodsId = this.spreadGoodsId
      http.postFront1(protocolSS.param_deleteSpreadGoods).then(response => {
        if (response.data) {
          this.$message(response.data.message)
          if (response.data && response.data.code == '0') {
            setTimeout(() => {
              that.showData()
              that.dialogVisible1 = false
            }, window.g.Interface_latency_Time && 800)
          }
        }
      })
    },
    cancleOrder(item) {
      this.spreadGoodsId = item.spreadGoodsId
      this.dialogVisible1 = true
    },
    // 分页
    handleSizeChange(val) {
      this.pageData.pageSize = val
      this.showData()
    },
    handleCurrentChange(val) {
      this.pageData.currentPage = val
      this.showData()
    },
    // 订单展示
    showData() {
      const that = this
      this.loading = true
      protocolSS.param_getSpreadQuery.param.firmId = this.sessionInfoGetter.firmId
      protocolSS.param_getSpreadQuery.param.page = this.pageData.currentPage - 1
      protocolSS.param_getSpreadQuery.param.size = '' + this.pageData.pageSize
      protocolSS.param_getSpreadQuery.param.bsFlag = 'B'
      protocolSS.param_getSpreadQuery.param.sort = [{
        direction: 'DESC',
        property: 'deliveryId'
      }]
      http.postFront1(protocolSS.param_getSpreadQuery).then(response => {
        if (response.data.code != 0) {
          this.$message({ message: response.data.message })
          this.isNetWrong = true
        } else {
          this.isNetWrong = false
        }
        if (response.data) {
          if (response.data && response.data.code == '0') {
            this.pageData.total = response.data.value.totalElements
            const arr = response.data.value.content
            this.each(arr, function(arrIndex) {
              arrIndex.ChBsFlag = arrIndex.bsFlag === 'B' ? '买' : '卖'
            })
            this.tableData = arr
          }
        }
        this.loading = false
      }).catch((e) => {
        this.loading = false
        setTimeout(() => {
          that.showData()
        }, 1000)
      })
    }
  }

}
</script>